import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  getStarted: {
    id: 'UserProfileDropdown.getStarted',
    defaultMessage: 'Get started with any product'
  },
  cloudProducts: {
    id: 'UserProfileDropdown.cloudProducts',
    defaultMessage: 'My cloud products'
  },
  cloudProductsMobile: {
    id: 'UserProfileDropdown.cloudProductsMobile',
    defaultMessage: 'MY CLOUD PRODUCTS'
  },
  activeSites: {
    id: 'UserProfileDropdown.activeSites',
    defaultMessage: 'Active in {sites} sites:'
  },
  profile: {
    id: 'UserProfileDropdown.profile',
    defaultMessage: 'Profile'
  },
  licenses: {
    id: 'UserProfileDropdown.licenses',
    defaultMessage: 'Licenses'
  },
  logOut: {
    id: 'UserProfileDropdown.logOut',
    defaultMessage: 'Log Out'
  },
  switchAccount: {
    id: 'UserProfileDropdown.switchAccount',
    defaultMessage: 'Switch Account'
  }
});
